export class Solicitud {
	constructor(
		public id: number,
		public grupo_id: number,
		public nombre: string,
		public apellidos: string,
		public email: string,
		public re_email: string,
		public telefono: string,
		public licencia_funcionamiento: string,
		public nombre_establecimiento: string,
		public img: string,
		public estatus: string
	) { }
}